import { useCallback, useEffect, useState } from 'react';
import { LoadingScreen } from '../components/atoms/LoadingScreen';
import { useAppDispatch } from '../store/hooks';
import { loadAppAsync } from '../store/user/userActions';
import { MainNavigator } from './MainNavigator';

export const RootNavigator = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const init = async () => {
      await dispatch(loadAppAsync());
      setIsLoading(false);
    };

    init();
  }, [dispatch]);

  const getLoading = useCallback(() => {
    if (isLoading) return <LoadingScreen />;
  }, [isLoading]);

  const getNavigator = useCallback(() => {
    if (!isLoading) return <MainNavigator />;
  }, [isLoading]);

  return (
    <>
      {getLoading()}
      {getNavigator()}
    </>
  );
};
